export const isEnv = (env) =>
  process.env.REACT_APP_ENV_NAME?.toLowerCase()?.startsWith(env);

export const isDemoEnv = () => isEnv('demo');

export const isDevEnv = () => isEnv('dev');

export const isProdEnv = () => isEnv('prod');

export const isStageEnv = () => isEnv('stage');

export const isRCEnv = () => isEnv('rc');

export const getCDNBaseURL = () => {
  const baseURL = process.env.REACT_APP_CDN_URL;

  if (!baseURL) {
    return baseURL;
  }

  return baseURL.endsWith('/') ? baseURL : `${baseURL}/`;
};

const defaultExport = {
  getCDNBaseURL,
  isEnv,
  isDemoEnv,
  isDevEnv,
  isProdEnv,
  isStageEnv,
  isRCEnv,
};

export default defaultExport;
